const PRO_PLAN_NAME = 'Pro (2,000 Tasks)';
const PRO_PLAN_INTERVAL = 'year';
export const buildUpgradeUrl = (opts) => {
    const currentPlanName = (opts.currentPlanName || '').toLowerCase();
    const upgradePlanName = (opts.upgradePlanName || '').toLowerCase();
    const url = currentPlanName && upgradePlanName
        ? `/app/checkout/upgrade/${currentPlanName}/${upgradePlanName}?interval=${opts.interval || 'month'}`
        : '/app/pricing';
    return encodeURI(url);
};
export const getShouldRenderSunsetCopy = (campaignOffers = []) => {
    const hasSunsetOffer = campaignOffers.length &&
        campaignOffers.every((offer) => !offer.acceptedAt &&
            offer.expiry &&
            new Date(offer.expiry) >= new Date());
    return hasSunsetOffer;
};
export const getProfessionalPlanData = (possiblePlans, currentAccount) => {
    var _a;
    const professionalPlan = (_a = possiblePlans
        .find((plan) => plan.planType === 'Professional')) === null || _a === void 0 ? void 0 : _a.plans.find((plan) => plan.name === PRO_PLAN_NAME && plan.interval === PRO_PLAN_INTERVAL);
    const professionalUpgradeUrl = buildUpgradeUrl({
        currentPlanName: currentAccount.plan.name,
        upgradePlanName: (professionalPlan === null || professionalPlan === void 0 ? void 0 : professionalPlan.name) || PRO_PLAN_NAME,
        interval: currentAccount.plan.interval,
    });
    const professionalPlanAmount = ((professionalPlan === null || professionalPlan === void 0 ? void 0 : professionalPlan.amount) || 0) / 12;
    return { professionalUpgradeUrl, professionalPlanAmount };
};
//# sourceMappingURL=utils.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)
